import * as actionTypes from './actionTypes';
import store from "./store";
import {CUSTOMER_INSIGHTS_REDUX_STORE} from "./AppConstants";

export const setLoggedInUser = (userSession) => {
  return {
    type: actionTypes.SET_LOGGED_IN_USER,
    payload: userSession
  }
}

export const clearLoggedInUser = () => {
  return {
    type: actionTypes.CLEAR_LOGGED_IN_USER,
    payload: null
  }
}

export const setDetailsScreenIds = (detailsScreen) => {
  return {
    type: actionTypes.SET_DETAILS_SCREEN_IDS,
    payload: detailsScreen
  }
}

export const clearDetailsScreenIds = () => {
  return {
    type: actionTypes.CLEAR_DETAILS_SCREEN_IDS,
    payload: null
  }
}

export const logoutUserClearLocalStorage = () => {
  store.dispatch(clearLoggedInUser());
  store.dispatch(clearDetailsScreenIds());
  localStorage.removeItem(CUSTOMER_INSIGHTS_REDUX_STORE);
}
